import { LIST_PERSONAL_MAIL } from './constants'

export default {
  computed: {
    isValidEmail() {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      return emailRegex.test(this.formData?.workEmail)
    },
    isValidWorkEmail() {
      if (!this.isValidEmail) {
        return false
      }
      const [, domain] = this.formData?.workEmail?.split('@')
      if (!domain) {
        return false
      }
      return !LIST_PERSONAL_MAIL.some((pattern) => domain.startsWith(pattern))
    },
  },
}
